import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PartNumber from 'pu-react/components/PartNumber';
import Revision from 'pu-react/components/Revision';
import { changeGlobalParameter } from 'product_tabs/actions';
import { validator } from 'product_tabs/tab_project/utils/validator';
import GerberFile from 'shared/product_tabs/tab_project/components/ZipFile';


const Project = (projectProps) => {
  const dispatch = useDispatch();

  const {
    changeParameter,
    parameters,
    fabRequireFile,
    stencilRequireFile,
  } = projectProps;

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }))
    dispatch(changeGlobalParameter({ name, value }))
  }
  const props = {
    parameters,
    onChangeParameter,
  };

  return (
    <div className="project-information row">
      <div className="col-lg-2">
        <PartNumber
          {...props}
          errorMessage={validator.message('Part Number', parameters.part_number, 'required|min:3')} />
      </div>
      <div className="col-lg-2">
        <Revision
          {...props}
          errorMessage={validator.message('Revision', parameters.revision, 'required')} />
      </div>
      <div className="col-lg-2">
        <GerberFile
          {...props}
          label="Upload Zip File"
          text="Browse"
          validator={validator}
          fabRequireFile={fabRequireFile}
          stencilRequireFile={stencilRequireFile} />
      </div>
    </div>
  )
};

export default Project;
